<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchData" class="form-inline my-2 my-lg-0">
                    <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="รหัสสินค้า"
                        v-model="search.code"
                        aria-label="Search"/>
                    &nbsp;
                    <select class="form-control" v-model="search.type">
                        <option
                            v-for="options in optionProductType"
                            :value="options.value">{{ options.text }}
                        </option>
                    </select>
                    &nbsp;&nbsp;
                    <button @click="searchData"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp;&nbsp;
                    <button @click="showPrintProductPriceModal"
                            class="btn btn-primary my-2 my-sm-0"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์ใบเสนอราคา
                    </button>
                    &nbsp;&nbsp;
                    <button class="btn btn-warning my-2 my-sm-0"
                            v-if="canViewSuperAdmin"
                            @click="showProductTypeModal"
                            type="button">
                        <icon name="pencil-alt"></icon>
                        อัพเดตราคา +บาท
                    </button>
                    &nbsp;&nbsp;
                    <button class="btn btn-info my-2 my-sm-0"
                            v-if="canViewSuperAdmin"
                            @click="showCommissionProductModal"
                            type="button">
                        <icon name="pencil-alt"></icon>
                        ปรับค่าคอมรายสินค้า
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">จำนวนคงเหลือ</th>
                    <th scope="col">ราคา</th>
                    <th scope="col">ค่าคอมมิชชั่น</th>
                    <th scope="col">วันที่อัพเดตล่าสุด</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in product" v-if="data.cancel_status == null">
                    <td>{{ data.sku }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.quantity }}</td>
                    <td>{{ data.price }}</td>
                    <td>{{ data.commission }} %</td>
                    <td>{{ data.updated_at }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="product.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getProductsPage">
            </vue-pagination>
        </div>
        <b-modal hide-header hide-footer ref="print_product_price">
            <add-price-product-modal @submit="printProductPrice"></add-price-product-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="update_product_price">
            <add-price-for-type-modal @submit="updateProductPrice"></add-price-for-type-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="commission_product">
            <commission-product-modal @submit="updateCommissionProduct"></commission-product-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>

        <br>
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import AddProductModal from "../../Report/Product/AddProductReport";
import AddPriceProductModal from "./AddPriceProductModal";
import AddPriceForTypeModal from "./AddPriceForTypeModal";
import Loading from "../../Utility/Loading";
import {canViewSuperAdmin} from "../../../util/Permissions";
import CommissionProductModal from "./CommissionProductModal";

export default {
    components: {
        CommissionProductModal,
        Loading, AddPriceForTypeModal, AddPriceProductModal, AddProductModal, VuePagination
    },
    name: "stork-product",
    data() {
        return {
            event_submit: "",
            status_loading: 1,
            msg: '',
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            product: [],
        }
    },
    async created() {
        await this.$store.dispatch("Products/clearSearch");
        this.showLoadingModal();
        this.status_loading = 1;
        await this.$store.dispatch("Products/setProducts").then(res => {
            this.product = res.data;
            this.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
            this.hideLoadingModal();
        });
        await this.$store.dispatch('ProductType/get');
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            optionProductType: state => {
                return [
                    {
                        value: "",
                        text: "หมวดหมู่สินค้า"
                    },
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
            search: state => {
                return state.Products.search
            }
        })
    },
    methods: {
        showPrintProductPriceModal() {
            this.$refs.print_product_price.show();
        },
        hidePrintProductPriceModal() {
            this.$refs.print_product_price.hide();
        },
        showProductTypeModal() {
            this.$refs.update_product_price.show();
        },
        hideProductTypeModal() {
            this.$refs.update_product_price.hide();
        },
        showCommissionProductModal() {
            this.$refs.commission_product.show();
        },
        hideCommissionProductModal() {
            this.$refs.commission_product.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getProductsPage() {
            const page = this.dataPaginate.current_page;
            //paginate search
            if (this.event_submit) {
                this.$store.dispatch('Products/search', {
                    page: page,
                    code: this.search.code,
                    type: this.search.type
                }).then(res => {
                    this.product = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.form,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                });
            } else {
                //paginate get data
                this.$store.dispatch('Products/setProducts', page).then(res => {
                    this.product = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.form,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                })
            }
        },
        searchData() {
            this.event_submit = true;
            if (this.search.type === null) {
                this.search.type = "";
            }
            this.$store.dispatch("Products/searchStock", {
                page: 1,
                code: this.search.code,
                type: this.search.type
            }).then(res => {
                this.product = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.form,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
            });
        },
        printProductPrice(value) {
            if (value) {
                this.showLoadingModal();
                this.status_loading = 1;
                this.msg = 'กำลังเรียกรายงาน กรุณารอสักครู่';
                let data = {
                    add_foam: value.add_price_foam,
                    add_other: value.add_price_other,
                    product_type_id: value.product_type_id,
                    promotionOption: value.promotionOption,
                    promotionOption_type: value.promotionOption_type,
                    pack_type: value.pack_type
                };
                this.$store.dispatch("Products/printProductPromotion", data).then(res => {
                    this.showLoadingModal();
                    this.status_loading = 2;
                    this.msg = 'สำเร็จ';
                    window.open(res);
                });
            }
            this.hidePrintProductPriceModal();
        },
        updateProductPrice(value) {
            if (value) {
                this.showLoadingModal();
                this.status_loading = 1;
                this.msg = 'กำลังอัพเดต กรุณารอสักครู่';
                this.$store.dispatch("Products/updatePriceProduct", value).then(() => {
                    this.showLoadingModal();
                    this.status_loading = 2;
                    this.msg = 'อัพเดตราคา สำเร็จ';
                    this.getProductsPage();
                });
            }
            this.hideProductTypeModal();
        },
        updateCommissionProduct(value) {
            //console.log(value);
            if (value) {
                this.showLoadingModal();
                this.status_loading = 1;
                this.msg = "กำลังบันทึกข้อมูล กรุณารอสักครู่";
                this.$store.dispatch("Products/updateCommissionProduct", value).then(() => {
                    this.getProductsPage();
                    this.hideLoadingModal();
                }).catch(err => {
                    //console.log(err);
                    this.status_loading = 2;
                    this.msg = "บันทึกข้อมูลไม่สำเร็จ";
                })
            }
            this.hideCommissionProductModal();
        }
    }
}
</script>

<style scoped>

</style>
